var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2316 1.77755C11.9572 -0.410228 15.0519 -0.410223 15.7776 1.77755L17.3512 6.52185C17.6761 7.50145 18.5921 8.16268 19.6242 8.16268H24.6098C26.9416 8.16268 27.8982 11.1564 25.9984 12.5085L22.0505 15.3183C21.1938 15.928 20.8351 17.0253 21.1661 18.0233L22.694 22.6299C23.423 24.8275 20.9188 26.6774 19.0324 25.3348L14.8932 22.3889C14.0619 21.7973 12.9472 21.7973 12.116 22.3889L7.97669 25.3348C6.09029 26.6774 3.58617 24.8275 4.31511 22.6299L5.84305 18.0233C6.17408 17.0253 5.81535 15.928 4.95866 15.3183L1.01071 12.5085C-0.889061 11.1564 0.0675091 8.16268 2.39931 8.16268H7.38497C8.41705 8.16268 9.33303 7.50145 9.65795 6.52185L11.2316 1.77755Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b1f3035fd67329e854c951e7d051faed.svg";
export { ForwardRef as ReactComponent };